import { createReducer } from 'redux-act';
//
import * as actions from './actions';

const initialState = {
  schoolClass: null,
  schoolClassStudents: [],
  schoolClassResults: {
    data: [],
  },
};

const SchoolClassesReducer = createReducer(
  {
    [actions.clearSchoolClassStateSuccess]: (state) => ({
      ...state,
      schoolClass: null,
      schoolClassStudents: [],
    }),
    [actions.fetchStaffSchoolClassesSuccess]: (state, payload) => ({
      ...state,
      schoolClassResults: payload,
    }),
    [actions.fetchSchoolClassSuccess]: (state, payload) => ({
      ...state,
      schoolClass: payload,
    }),
    [actions.patchSchoolClassSuccess]: (state, payload) => ({
      ...state,
      schoolClass: payload,
    }),
    [actions.setSchoolClassStudents]: (state, payload) => ({
      ...state,
      schoolClassStudents: payload,
    }),
  },
  initialState
);

export default SchoolClassesReducer;
